<div class="container-fluid">

  <div class="row s-contentheader">
    <div class="col-md-12">
      <div>
        <h2 class="text-center">{{customLabel('CURSUS', 'menuCYC')}} <i>({{nbCycle}})</i></h2>
        <div class="s-dividerx"></div>
        <p>
          <!--<div class="input-group w-50 mx-auto">
            <input type="text" class="form-control s-round" placeholder="Rechercher dans les catalogues..." aria-label="Recipient's username" aria-describedby="basic-addon2">
            <span class="input-group-addon s-round"><i class="fa fa-search"></i></span>
          </div>-->
        </p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-3">

      <div class="card p-4 mb-3 s-listfilter">
        <h5 class="font-weight-bold">{{'filterLST'|localize}}</h5>

        <div>
          <a (click)="getAllCycles()" class="ispointer"><i class="fa fa-asterisk"></i>{{'allcursus'|localize}}</a>
        </div>

        <div *ngFor="let y of yearList;let i = index">
          <a data-toggle="collapse" href="#collapse{{i}}" title="{{'filterSDT'|localize}} {{y.Year}}">
            <i class="fa fa-chevron-right"></i>{{y.Year}}
          </a>
          <div id="collapse{{i}}" class="panel-collapse collapse">
            <div class="mt-2 ml-5" *ngFor="let m of y.MonthsList">
              <a (click)="filterCycles(y.Year, m.MonthsNumber)"><i class="fa fa-filter"></i>{{m.MonthDef}}</a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-7">

      <div class="row s-listcontent" *ngFor="let cycle of cyclesFiltered">
        <div class="col-md-6" *ngFor="let c of cycle.listFils">
          <div class="card s-listcard ispointer" (click)="selectCycle(c)">
            <div class="row no-gutters">
              <div class="col-auto">
                <div class="s-listcardborder">&nbsp;</div>
                <!--<img src="images/test3.png" class="s-imgfluid" alt="" />-->
              </div>
              <div class="col">
                <div class="card-block px-2 s-listcardblock">
                  <h5>{{c.ValueDOS}}</h5>
                  <h6>{{'from'|localize}} {{c.DateDDos}} {{'to'|localize}} {{c.DateFDOS}}</h6>
                  <p>&nbsp;</p>
                </div>
              </div>
            </div>

            <div class="s-listcardfooter">
              <a (click)="selectCycle(c)" class="float-right mr-4"><i class="fa fa-search"></i></a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-sm-2">
      <button type="button" class="btn s-btncircle btn-lg s-btnbottom" (click)="store.openPage('/home/base')">
        <i class="fa fa-arrow-left 2x"></i>
      </button>
    </div>
  </div>

</div>
